import { Route } from 'react-router';
import SubNavigationLayout from '../../common/components/SubNavigationLayout';
import ErrorBoundary from '../../common/error/ErrorBoundary';
import SubMenu from '../navigation/SubMenu';
import Members from './Members';
import PendingMembers from './PendingMembers';

/**
 * Members/Access feature routes
 * Base path: members/
 */
export const memberRoutes = (
    <Route
        element={
            <SubNavigationLayout
                subNavigation={
                    <ErrorBoundary key="/submenu/members">
                        <SubMenu parentId="members" />
                    </ErrorBoundary>
                }
            />
        }
    >
        <Route
            index
            element={
                <ErrorBoundary key="members">
                    <Members />
                </ErrorBoundary>
            }
        />
        <Route
            path="pending"
            element={
                <ErrorBoundary key="members/pending">
                    <PendingMembers />
                </ErrorBoundary>
            }
        />
    </Route>
);
